import type { MedSummaryData, MedSummaryDataUpdate } from "../types/summary";
import type { APIInstance } from "./apiService";
import {
  type MedSummaryDataEditResponse,
  MedSummaryDataEditResponseSchema,
} from "./summaryServiceV2.types";

export class SummaryServiceV2 {
  private api: APIInstance;

  constructor(api: APIInstance) {
    this.api = api;
  }

  async getSummary(caseId: string, versionId: string): Promise<MedSummaryData> {
    const response = await this.api.get<MedSummaryData>(
      `/cases/${caseId}/versions/${versionId}/summary`
    );
    return response.data;
  }

  async updateSummary(
    caseId: string,
    versionId: string,
    data: MedSummaryDataUpdate
  ): Promise<MedSummaryDataEditResponse> {
    const response = await this.api.patch(`/cases/${caseId}/versions/${versionId}/summary`, data);
    return MedSummaryDataEditResponseSchema.parse(response.data);
  }
}
